/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { jsx } from '@emotion/core';

export default (props: {
  errors: string[],
  isLoading: boolean,
}): null | Element<string> => {
  const { errors, isLoading } = props;
  return errors && errors.length > 0 && !isLoading ? (
    <div className="alert alert-danger pb-2 mt-2 pb-2">
      <ul className="m-0">
        {errors.map((v, i) => (
          <li key={i}>{String(v)}</li>
        ))}
      </ul>
    </div>
  ) : null;
};
